/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_Time_StretchInputs */



/**
* | output |
* | --- |
* | "Close Time Stretch" |
*
* @param {Close_Time_StretchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_time_stretch = /** @type {((inputs?: Close_Time_StretchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_Time_StretchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fermer étirement du timecode")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitdehnung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Chiudi Time Stretch")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Затяжка короткого промежутка времени")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estiramiento de tiempo de cierre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("接近时间拉伸")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイムストレッチを閉じる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय अंतराल समाप्त")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fechar Tempo Esticar")
	return /** @type {LocalizedString} */ ("Close Time Stretch")
});